import { Link } from "wouter";
import { ChevronRight } from "lucide-react";

interface ServiceCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  link: string;
}

const ServiceCard = ({ icon, title, description, link }: ServiceCardProps) => {
  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden transition-all duration-300 hover:transform hover:-translate-y-1 hover:shadow-lg">
          <div className="bg-primary h-16 flex items-center justify-center">
              <div className="h-48px w-48px text-black text-5xl">{icon}</div>
      </div>
      <div className="p-6">
        <h3 className="text-xl font-heading font-semibold text-neutral-800 mb-3">{title}</h3>
        <p className="text-neutral-800 mb-4">
          {description}
        </p>
        <Link href={link}>
          <span className="inline-flex items-center text-primary font-medium cursor-pointer">
            Learn more
            <ChevronRight className="w-4 h-4 ml-2" />
          </span>
        </Link>
      </div>
    </div>
  );
};

export default ServiceCard;
